import { render, staticRenderFns } from "./SxyRepayModal.vue?vue&type=template&id=b30b3bd4&"
import script from "./SxyRepayModal.vue?vue&type=script&lang=js&"
export * from "./SxyRepayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports